import { MbscCalendarEventData } from '@mobiscroll/react';
import { Repeat } from '@mui/icons-material';
import { Box, Chip, Stack, Typography } from '@mui/material';
import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';

export interface IEventLabelProps {
    event: MbscCalendarEventData & { IsLostInsuranceCoverage?: boolean; IsPreparingForGraduation?: boolean };
}

const EventContent: React.FC<IEventLabelProps> = (props) => {
    const { event } = props;
    let recurrenceIcon = null;
    if (event.original.recurring) {
        recurrenceIcon = (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 18, // Adjust this value as needed
                    height: 15, // Adjust this value as needed
                    borderRadius: '4px',
                    color: 'white',
                }}
            >
                <Repeat
                    sx={{ transform: 'scale(0.6)' }} // Adjust this value as needed
                />
            </Box>
        );
    }

    let lostInsuranceCoverageIcon = null;
    let preparingForGraduation = null;
    if (event.original.IsLostInsuranceCoverage) {
        lostInsuranceCoverageIcon = <Chip sx={{ maxHeight: 14, fontSize: 8 }} size="small" label="LostIns" color="warning" />;
    }
    if (event.original.IsPreparingForGraduation) {
        preparingForGraduation = <Chip sx={{ maxHeight: 14, fontSize: 8 }} size="small" label="PrepGrad" color="warning" />;
    }
    return (
        <>
            <Stack direction={'row'} spacing={1}>
                {event.original.HasWarningFlag ? <WarningIcon sx={{ fontSize: 'inherit', color: 'red' }} /> : null}
                {recurrenceIcon}
                {lostInsuranceCoverageIcon}
                {preparingForGraduation}
            </Stack>

            <Stack spacing={1} alignItems="flex-start" justifyContent={'flex-start'}>
                <Typography variant="body2">{event.original.MemberName ?? event.title}</Typography>
            </Stack>
        </>
    );
};

export default EventContent;
